import { render, staticRenderFns } from "./OneOrThreeWeekAddV5.vue?vue&type=template&id=4452b3d3&"
import script from "./OneOrThreeWeekAddV5.vue?vue&type=script&lang=ts&"
export * from "./OneOrThreeWeekAddV5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports